import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { massopsRouter } from './routing/massopsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { massopsViewOnlyAccessControl } from './access-control/massopsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'massops',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'massops-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [massopsRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      attachToV3: AdminNavEntryPointV3.CustomersAndOrders,
      subNavItems: [
        {
          route: 'massops-interventions',
          subRoutes: [
            'massops-admin',
            'massops-create-intervention',
            'massops-dashboard',
            'massops-intervention',
            'massops-intervention-settings',
          ],
          labelId: 'massopsDomain.interventions.title',
          accessControl: massopsViewOnlyAccessControl,
        },
      ],
    },
  ],
}

export default definition
